import React from 'react';
import { Link } from 'react-router-dom';
import { useTierPortfolio } from '../../hooks/useTierPortfolio';
import { mapThesisTimeframeToRiskTiers } from '../../tiers/tierCatalog';
import TierChip from './TierChip';
import { ThesisTimeframe } from '../../tiers/tierCatalog';

interface Props {
  title?: string;
  description?: string;
  /** When set, show which catalog tiers typically consume this thesis horizon */
  thesisTimeframe?: ThesisTimeframe;
  primaryTier?: 1 | 6;
  settingsHint?: boolean;
}

const TierPageBanner: React.FC<Props> = ({
  title = 'Tier context',
  description,
  thesisTimeframe,
  primaryTier,
  settingsHint = true,
}) => {
  const { tierFilter } = useTierPortfolio();
  const tiers = thesisTimeframe
    ? mapThesisTimeframeToRiskTiers(thesisTimeframe)
    : [];

  return (
    <div className="mb-6 rounded-xl border border-slate-200 bg-gradient-to-r from-slate-50 to-white px-4 py-3 shadow-sm">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">
            {title}
          </p>
          {description ? (
            <p className="mt-1 text-sm text-slate-700">{description}</p>
          ) : null}
          {primaryTier ? (
            <p className="mt-2 text-sm text-slate-600">
              Primary consumer:{' '}
              <TierChip riskTier={primaryTier} size="md" className="ml-1" />
            </p>
          ) : null}
          {tiers.length > 0 ? (
            <div className="mt-2 flex flex-wrap items-center gap-1.5">
              <span className="text-xs text-slate-500">Thesis feeds:</span>
              {tiers.map((t) => (
                <TierChip
                  key={t}
                  riskTier={t}
                  variant={tierFilter !== 'all' && tierFilter !== t ? 'inactive' : 'default'}
                />
              ))}
            </div>
          ) : null}
        </div>
        {settingsHint ? (
          <Link
            to="/app/settings"
            className="text-sm font-medium text-primary-600 hover:text-primary-700"
          >
            Portfolio setup
          </Link>
        ) : null}
      </div>
    </div>
  );
};

export default TierPageBanner;
